import axios from 'axios';
import { getAxiosWithCache } from '../axios';
import { API_URL } from '../config';

const axiosWithCache = getAxiosWithCache();

export const fetchBanks = () => {
  const URL = `${API_URL}/bank`;
  return axiosWithCache.get(URL).then((resp) => resp.data.banks);
};

export const fetchRepairCompanies = () => {
  const URL = `${API_URL}/repair-company`;
  return axiosWithCache.get(URL).then((resp) => resp.data.repairCompanies);
};

export const checkVehicleInsurance = (data) => {
  const URL = `${API_URL}/claim-application/check-vehicle-insurance`;
  return axios.post(URL, data).then((resp) => resp.data);
};

export const fetchPropertyTypes = () => {
  const URL = `${API_URL}/property-type`;
  return axiosWithCache.get(URL).then((resp) => resp.data.propertyTypes);
};

export const fetchDamageCauses = () => {
  const URL = `${API_URL}/damage-cause`;
  return axiosWithCache.get(URL).then((resp) => resp.data.damageCauses);
};

export const fetchOrganizations = () => {
  const URL = `${API_URL}/organization`;
  return axiosWithCache.get(URL).then((resp) => resp.data.organizations);
};
